import { useEffect } from 'react';
import {
  getLastActiveAt,
  markSessionActive,
  refreshSession,
  sendSessionHeartbeat,
  SESSION_STALE_MS,
} from '../utils/authSession';

const useTokenRefresh = (isUserLoggedIn) => {
  useEffect(() => {
    if (!isUserLoggedIn) return;

    markSessionActive(true);

    const refreshInterval = setInterval(async () => {
      try {
        if (localStorage.getItem('refresh_token')) await refreshSession('scheduled_refresh');
      } catch (error) {
        console.error("Error refreshing token:", error);
      }
    }, 14 * 60 * 1000);

    const heartbeatInterval = setInterval(() => {
      sendSessionHeartbeat('periodic_heartbeat');
    }, 5 * 60 * 1000);

    const handleActivity = () => {
      markSessionActive();
    };

    const handleWake = async () => {
      const lastActiveAt = getLastActiveAt();
      const inactiveMs = lastActiveAt ? Date.now() - lastActiveAt : 0;
      markSessionActive(true);

      if (inactiveMs >= SESSION_STALE_MS) {
        try {
          await refreshSession('wake_after_24h');
          await sendSessionHeartbeat('wake_after_24h', inactiveMs);
          window.location.reload();
        } catch (error) {
          console.error("Error refreshing session after wake:", error);
        }
      } else {
        sendSessionHeartbeat('wake', inactiveMs);
      }
    };

    const wakeEvents = ['focus', 'pageshow'];
    const activityEvents = ['click', 'keydown', 'mousemove', 'touchstart', 'scroll'];
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') handleWake();
    };

    wakeEvents.forEach((eventName) => window.addEventListener(eventName, handleWake));
    document.addEventListener('visibilitychange', handleVisibilityChange);
    activityEvents.forEach((eventName) => window.addEventListener(eventName, handleActivity, { passive: true }));

    sendSessionHeartbeat('login_or_reload');

    return () => {
      clearInterval(refreshInterval);
      clearInterval(heartbeatInterval);
      wakeEvents.forEach((eventName) => window.removeEventListener(eventName, handleWake));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      activityEvents.forEach((eventName) => window.removeEventListener(eventName, handleActivity));
    };
  }, [isUserLoggedIn]);
};

export default useTokenRefresh;
